import { useEffect, useState } from 'react';

/**
 * Blob como URL local (blob:), liberada quando o blob muda ou o componente
 * sai. Sem blob, devolve `null` — nunca uma URL já liberada.
 */
export function useObjectUrl(blob: Blob | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!blob) {
      setUrl(null);
      return undefined;
    }
    const next = URL.createObjectURL(blob);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [blob]);
  return url;
}
